export const conditionDetailsOptions = [
  {
    label: 'Very Bad',
    value: 'Very bad',
  },
  {
    label: 'Bad',
    value: 'Bad',
  },
  {
    label: 'Moderate',
    value: 'Moderate',
  },
  {
    label: 'Good',
    value: 'Good',
  },
  {
    label: 'Very Good',
    value: 'Very good',
  },
];

export const propertyTypeGroupOptions = [
  {
    label: 'Single',
    value: 'single',
  },
  {
    label: 'Multi',
    value: 'multi',
  },
];